export const restList = [
    {
        type : "restaurant",
        data : {
            type: "F",
            id : 323122,
            name : "Burger King",
            uuid : "13131311212",
            city : "kalyan",
            cusine : "Burger, Rolls, French fries",
            rating : "4.5 stars",
            rate : 4.5,
            photo : "https://cdn.vectorstock.com/i/500p/22/07/burger-icon-isolated-flat-cartoon-sandwich-vector-15262207.jpg"
        }
    },
    {
        type : "claud kitchen",
        data : {
            type: "F",
            id : 323124,
            name : "Annas Kitchen",
            uuid : "13131311212",
            city : "Dombivli",
            cusine : "Thali, North & South indian, Soft Drinks and bevarage",
            rating : "3.2 stars",
            rate : 3.2,
            photo : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyZfxNY8r2-a60xbloK3hQwgqV9ezYFqJlzg&s"
        }
    },
    {
        type : "Resto Bar",
        data : {
            type: "F",
            id : 323126,
            name : "Xamrin Resto Bar",
            uuid : "13131311212",
            city : "Manpada",
            cusine : "Indian Cusines, Chinese, Mexican, Italian, Bear and Cocktails",
            rating : "4.9 stars",
            rate : 4.9,
            photo : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJl0nGCPWmVgaoLBHNR3lxTHy0m9OqaFwlGg&s"
        }
    },
    {
        type : "restaurant",
        data : {
            type: "F",
            id : 341313,
            name : "Jombo King",
            uuid : "13131311212",
            city : "kalyan",
            cusine : "Burger, Rolls, French fries",
            rating : "3.5 stars",
            rate : 3.5,
            photo : "https://cdn.vectorstock.com/i/500p/22/07/burger-icon-isolated-flat-cartoon-sandwich-vector-15262207.jpg"
        }
    },
    {
        type : "restaurant",
        data : {
            type: "F",
            id : 342123,
            name : "SVG",
            uuid : "13131311212",
            city : "kalyan",
            cusine : "Burger, Rolls, French fries",
            rating : "2.1 stars",
            rate : 2.1,
            photo : "https://cdn.vectorstock.com/i/500p/22/07/burger-icon-isolated-flat-cartoon-sandwich-vector-15262207.jpg"
        }
    }
] 

export const RestAdvanceList = [
  {
    "text": "INDO CHINESE",
    "highlightedText": "INDO CHINESE {{THANE}}",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/29/22d6f80a-6769-4a4d-9526-54b893aa909f_667248 SS.jpg",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":524220,\"primaryRestaurantId\":667248,\"cloudinaryId\":\"RX_THUMBNAIL/IMAGES/VENDOR/2024/6/29/22d6f80a-6769-4a4d-9526-54b893aa909f_667248 SS.jpg\",\"brandId\":524220,\"dishFamilyId\":\"846613\",\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "INDO CHINESE",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=INDO%20CHINESE%20THANE&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A524220%2C%22primaryRestaurantId%22%3A667248%2C%22cloudinaryId%22%3A%22RX_THUMBNAIL%2FIMAGES%2FVENDOR%2F2024%2F6%2F29%2F22d6f80a-6769-4a4d-9526-54b893aa909f_667248%20SS.jpg%22%2C%22brandId%22%3A524220%2C%22dishFamilyId%22%3A%22846613%22%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/500p/37/31/vibrant-of-fresh-asian-spring-rolls-with-dip-vector-58593731.avif',
    "disabled": false
  },
  {
    "text": "Spice Village",
    "highlightedText": "{{Spice}} Village",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "spice_village_001",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100001,\"primaryRestaurantId\":200001,\"cloudinaryId\":\"spice_village_001\",\"brandId\":100001,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Spice Village",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Spice%20Village&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100001%2C%22primaryRestaurantId%22%3A200001%2C%22cloudinaryId%22%3A%22spice_village_001%22%2C%22brandId%22%3A100001%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/21/79/hot-chili-pepper-vector-20982179.avif',
    "disabled": false
  },
  {
    "text": "Dragon Wok",
    "highlightedText": "{{Dragon}} Wok",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "dragon_wok_002",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100002,\"primaryRestaurantId\":200002,\"cloudinaryId\":\"dragon_wok_002\",\"brandId\":100002,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Dragon Wok",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Dragon%20Wok&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100002%2C%22primaryRestaurantId%22%3A200002%2C%22cloudinaryId%22%3A%22dragon_wok_002%22%2C%22brandId%22%3A100002%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/04/26/chinese-restaurant-furniture-and-interior-design-vector-23870426.avif',
    "disabled": false
  },
  {
    "text": "The Continental Table",
    "highlightedText": "{{The}} Continental Table",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "continental_table_003",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100003,\"primaryRestaurantId\":200003,\"cloudinaryId\":\"continental_table_003\",\"brandId\":100003,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "The Continental Table",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=The%20Continental%20Table&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100003%2C%22primaryRestaurantId%22%3A200003%2C%22cloudinaryId%22%3A%22continental_table_003%22%2C%22brandId%22%3A100003%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/500p/70/44/cozy-coffee-shop-interior-vector-28997044.webp',
    "disabled": false
  },
  {
    "text": "Pasta Heaven",
    "highlightedText": "{{Pasta}} Heaven",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "pasta_heaven_004",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100004,\"primaryRestaurantId\":200004,\"cloudinaryId\":\"pasta_heaven_004\",\"brandId\":100004,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Pasta Heaven",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Pasta%20Heaven&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100004%2C%22primaryRestaurantId%22%3A200004%2C%22cloudinaryId%22%3A%22pasta_heaven_004%22%2C%22brandId%22%3A100004%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/23/35/delicious-pasta-dish-vector-5172335.avif',
    "disabled": false
  },
  {
    "text": "Cantina Loca",
    "highlightedText": "{{Cantina}} Loca",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "cantina_loca_005",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100005,\"primaryRestaurantId\":200005,\"cloudinaryId\":\"cantina_loca_005\",\"brandId\":100005,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Cantina Loca",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Cantina%20Loca&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100005%2C%22primaryRestaurantId%22%3A200005%2C%22cloudinaryId%22%3A%22cantina_loca_005%22%2C%22brandId%22%3A100005%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/26/27/delicious-creamy-pasta-with-fresh-tomatoes-vector-53102627.avif',
    "disabled": false
  },
  {
    "text": "Tandoori Nights",
    "highlightedText": "{{Tandoori}} Nights",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "tandoori_nights_006",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100006,\"primaryRestaurantId\":200006,\"cloudinaryId\":\"tandoori_nights_006\",\"brandId\":100006,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Tandoori Nights",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Tandoori%20Nights&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100006%2C%22primaryRestaurantId%22%3A200006%2C%22cloudinaryId%22%3A%22tandoori_nights_006%22%2C%22brandId%22%3A100006%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/93/36/food-service-tray-icon-vector-5979336.webp',
    "disabled": false
  },
  {
    "text": "Peking House",
    "highlightedText": "{{Peking}} House",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "peking_house_007",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100007,\"primaryRestaurantId\":200007,\"cloudinaryId\":\"peking_house_007\",\"brandId\":100007,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Peking House",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Peking%20House&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100007%2C%22primaryRestaurantId%22%3A200007%2C%22cloudinaryId%22%3A%22peking_house_007%22%2C%22brandId%22%3A100007%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/500p/15/70/asian-food-platter-top-view-vector-58591570.avif',
    "disabled": false
  },
  {
    "text": "Cafe Europa",
    "highlightedText": "{{Cafe}} Europa",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "cafe_europa_008",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100008,\"primaryRestaurantId\":200008,\"cloudinaryId\":\"cafe_europa_008\",\"brandId\":100008,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Cafe Europa",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Cafe%20Europa&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100008%2C%22primaryRestaurantId%22%3A200008%2C%22cloudinaryId%22%3A%22cafe_europa_008%22%2C%22brandId%22%3A100008%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/36/36/english-breakfast-with-egg-and-sausages-tomatoes-vector-47863636.avif',
    "disabled": false
  },
  {
    "text": "La Piazza",
    "highlightedText": "{{La}} Piazza",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "la_piazza_009",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100009,\"primaryRestaurantId\":200009,\"cloudinaryId\":\"la_piazza_009\",\"brandId\":100009,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "La Piazza",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=La%20Piazza&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100009%2C%22primaryRestaurantId%22%3A200009%2C%22cloudinaryId%22%3A%22la_piazza_009%22%2C%22brandId%22%3A100009%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/85/10/pepperoni-pizza-vector-3268510.avif',
    "disabled": false
  },
  {
    "text": "Taco Fiesta",
    "highlightedText": "{{Taco}} Fiesta",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "taco_fiesta_010",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100010,\"primaryRestaurantId\":200010,\"cloudinaryId\":\"taco_fiesta_010\",\"brandId\":100010,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Taco Fiesta",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Taco%20Fiesta&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100010%2C%22primaryRestaurantId%22%3A200010%2C%22cloudinaryId%22%3A%22taco_fiesta_010%22%2C%22brandId%22%3A100010%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/16/77/mexican-taco-ingredients-vector-14191677.avif',
    "disabled": false
  },
  {
    "text": "Bangkok Street",
    "highlightedText": "{{Bangkok}} Street",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "bangkok_street_011",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100011,\"primaryRestaurantId\":200011,\"cloudinaryId\":\"bangkok_street_011\",\"brandId\":100011,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Bangkok Street",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Bangkok%20Street&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100011%2C%22primaryRestaurantId%22%3A200011%2C%22cloudinaryId%22%3A%22bangkok_street_011%22%2C%22brandId%22%3A100011%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/09/61/asian-food-circle-diverse-cuisine-vector-50680961.avif',
    "disabled": false
  },
  {
    "text": "Spice & Sizzle",
    "highlightedText": "{{Spice}} & Sizzle",
    "type": "RESTAURANT",
    "suggestionType": "SUGGESTION_TYPE_LOW_CONFIDENCE",
    "marketplace": {
      "marketplaceId": "SWIGGY",
      "businessLineId": "FOOD"
    },
    "tagToDisplay": "Restaurant",
    "tagToDisplayColor": "#686B78",
    "cloudinaryId": "spice_sizzle_012",
    "metadata": "{\"type\":\"RESTAURANT\",\"data\":{\"parentId\":100012,\"primaryRestaurantId\":200012,\"cloudinaryId\":\"spice_sizzle_012\",\"brandId\":100012,\"enabled_flag\":1},\"businessCategory\":\"SWIGGY_FOOD\",\"displayLabel\":\"Restaurant\"}",
    "cta": {
      "text": "Spice & Sizzle",
      "type": "DEEPLINK",
      "link": "swiggy://explore?query=Spice%20%26%20Sizzle&metadata=%7B%22type%22%3A%22RESTAURANT%22%2C%22data%22%3A%7B%22parentId%22%3A100012%2C%22primaryRestaurantId%22%3A200012%2C%22cloudinaryId%22%3A%22spice_sizzle_012%22%2C%22brandId%22%3A100012%2C%22enabled_flag%22%3A1%7D%2C%22businessCategory%22%3A%22SWIGGY_FOOD%22%2C%22displayLabel%22%3A%22Restaurant%22%7D&marketplace=%7B%22marketplaceId%22%3A%22SWIGGY%22%2C%22businessLineId%22%3A%22FOOD%22%7D"
    },
    "category": "Food",
    "categoryColor": "#686B78",
    "subCategory": "Restaurant",
    "subCategoryColor": "#686B78",
    "restaurantId": 0,
    "Image" : 'https://cdn.vectorstock.com/i/750p/58/22/tuscan-seasoned-sausage-barbecue-grilling-vector-57325822.avif',
    "disabled": false
  }
];

export const viewRestoData = [
  { 
    "id": 1,
    "name" : "Abc",
    "price" : 200,
    "status" : "available"
  },
  { 
    "id": 2,
    "name" : "Pqr",
    "price" : 100,
    "status" : "available"
  },
  { 
    "id": 3,
    "name" : "STU",
    "price" : 150,
    "status" : "available"
  },
  { 
    "id": 4,
    "name" : "Def",
    "price" : 50,
    "status" : "available"
  },
  { 
    "id": 5,
    "name" : "Mnq",
    "price" : 250,
    "status" : "available"
  },
];